<template>
  <div class="sp-tab" :class="classModifiers" part="base">
    <sp-button variant="text" color="primary" part="activator">
      <slot />
    </sp-button>
  </div>
</template>

<script setup>
import { computed, watch } from "vue";

import { booleanAttribute, toBoolean } from "#ce/utils/props";

const emit = defineEmits(["update-active"]);

const props = defineProps({
  panel: {
    type: String,
    required: true,
  },
  active: booleanAttribute(),
});

const isActive = computed(() => toBoolean(props.active));

const classModifiers = computed(() => ({
  "--is-active": isActive.value,
}));

watch(isActive, (value) => {
  emit("update-active", value);
});
</script>

<style>
:host {
  display: block;
}
</style>

<style scoped lang="scss">
.sp-tab {
  --sp-comp-button-border-radius: var(--sp-comp-tab-button-border-radius, 0);
  --sp-comp-button-text-color: var(--sp-comp-tab-button-text-color, #aaa);
  --sp-comp-button-default-hover-text-color: var(--sp-sys-color-primary);
}
</style>
